import { METAL_ROOF_CDN_PATH } from '../../metal-roof-constants';

export const METAL_ROOF_PARTNERS_LIST = [
  {
    alt: 'Логотип Knaufinsulation',
    src: `${METAL_ROOF_CDN_PATH}/partners/knauf.jpg/knauf.jpg`,
  },
  {
    alt: 'Логотип Docke',
    src: `${METAL_ROOF_CDN_PATH}/partners/docke.jpg/docke.jpg`,
  },
  {
    alt: 'Логотип Grand Line',
    src: `${METAL_ROOF_CDN_PATH}/partners/grand-line.jpg/grand-line.jpg`,
  },
  {
    alt: 'Логотип Technonicole',
    src: `${METAL_ROOF_CDN_PATH}/partners/technonicole.jpg/technonicole.jpg`,
  },
  {
    alt: 'Логотип Onduline',
    src: `${METAL_ROOF_CDN_PATH}/partners/onduline.jpg/onduline.jpg`,
  },
  {
    alt: 'Логотип Brit',
    src: `${METAL_ROOF_CDN_PATH}/partners/brit.jpg/brit-2.jpg`,
  },
  {
    alt: 'Логотип Fakro',
    src: `${METAL_ROOF_CDN_PATH}/partners/fakro.jpg/fakro.jpg`,
  },
];
